/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentEnquiry_development$ref = any;
type DevelopmentProductDetails_product$ref = any;
type MappingImage_image$ref = any;
type MappingImage_products$ref = any;
export type DevelopmentRegistrationType = "complete_registration" | "normal_enquiry";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentProductSelectionDialog_development$ref: FragmentReference;
declare export opaque type DevelopmentProductSelectionDialog_development$fragmentType: DevelopmentProductSelectionDialog_development$ref;
export type DevelopmentProductSelectionDialog_development = {|
  +id: string,
  +mappingImage: ?{|
    +$fragmentRefs: MappingImage_image$ref
  |},
  +currentUserRegistrationForm: ?{|
    +id: string,
    +product: ?{|
      +id: string
    |},
  |},
  +registrationType: DevelopmentRegistrationType,
  +products: $ReadOnlyArray<{|
    +id: string,
    +lotReference: ?string,
    +status: string,
    +$fragmentRefs: DevelopmentProductDetails_product$ref & MappingImage_products$ref,
  |}>,
  +$fragmentRefs: DevelopmentEnquiry_development$ref,
  +$refType: DevelopmentProductSelectionDialog_development$ref,
|};
export type DevelopmentProductSelectionDialog_development$data = DevelopmentProductSelectionDialog_development;
export type DevelopmentProductSelectionDialog_development$key = {
  +$data?: DevelopmentProductSelectionDialog_development$data,
  +$fragmentRefs: DevelopmentProductSelectionDialog_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentProductSelectionDialog_development",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "mappingImage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MappingImage_image"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentRegistrationForm",
      "kind": "LinkedField",
      "name": "currentUserRegistrationForm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lotReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DevelopmentProductDetails_product"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MappingImage_products"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentEnquiry_development"
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd9feed27a9f245239dd01c7959cc1fbb';

export default node;
